import ApiService from "@/core/services/api.service";

// action types
export const FETCH_ADMIN_PROGRAMS = "fetchAdminPrograms";

// mutation types
export const SET_ADMIN_PROGRAMS = "setAdminPrograms";
export const SET_ADMIN_PROGRAMS_PAGINATION = "setAdminProgramsPagination";

const state = {
  adminPrograms: [],
  adminProgramsPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  }
};

const getters = {
  adminPrograms(state) {
    return state.adminPrograms;
  },
  adminProgramsPagination(state) {
    return state.adminProgramsPagination;
  }
};

const actions = {
  [FETCH_ADMIN_PROGRAMS](context, params = {}) {
    if (params.page === undefined) {
      params.page = context.state.adminProgramsPagination.currentPage;
    }

    return new Promise((resolve, reject) => {
      ApiService.query("admin/programs", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_PROGRAMS, data.data);
          context.commit(SET_ADMIN_PROGRAMS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_ADMIN_PROGRAMS](state, adminPrograms) {
    state.adminPrograms = adminPrograms;
  },
  [SET_ADMIN_PROGRAMS_PAGINATION](state, data) {
    state.adminProgramsPagination = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
